import { useEffect } from 'react';

import { toast } from 'src/components/snackbar';
import { Iconify } from 'src/components/iconify';

import { checkConfigVersion } from '../utils/checkversion';

const UPDATE_AVAILABLE_TOAST_ID = 'update-available';
const REMIND_AGAIN_MS = 10 * 60_000;

/** Watches for a new deploy and, once one lands, shows the new-version toast. Renders nothing. */
export function UpdateAvailableWatcher() {
  useEffect(() => {
    checkConfigVersion(({ reload }) => showUpdateAvailableToast(reload));
  }, []);

  return null;
}

/**
 * A toast that waits at the bottom left, clear of other toasts, until the user refreshes. Later,
 * or swiping it away, only puts it off: the version check stops once it has found a new build,
 * so this toast is the only reminder, and it comes back ten minutes later. Its fixed id keeps it
 * to one at a time.
 */
function showUpdateAvailableToast(onRefresh: () => void) {
  const remindLater = () => {
    setTimeout(() => showUpdateAvailableToast(onRefresh), REMIND_AGAIN_MS);
  };

  toast('New version available', {
    id: UPDATE_AVAILABLE_TOAST_ID,
    description: 'Refresh to get the latest improvements.',
    icon: <Iconify icon="solar:refresh-circle-bold" />,
    position: 'bottom-left',
    duration: Infinity,
    closeButton: false,
    action: { label: 'Refresh', onClick: onRefresh },
    cancel: { label: 'Later', onClick: remindLater },
    onDismiss: remindLater,
  });
}
